import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Full-page "couldn't load the report" state, shown in place of a report's
 * content when its very first load fails (see each report's
 * `showFullPageError` getter) - e.g. analytics, QR lifecycle and product
 * intelligence. Picks up the host page's --card/--border/--text theme
 * variables (declared per-page, e.g. analytics.component.css's .az-page),
 * so it renders correctly in both light and dark mode without its own
 * theme block.
 */
@Component({
  selector: "app-report-error-state",
  templateUrl: "./report-error-state.component.html",
  styleUrls: ["./report-error-state.component.css"],
})
export class ReportErrorStateComponent {
  @Input() title = "We're having trouble loading the report";
  @Input() message =
    "This might be due to a slow network or the server taking longer than expected.";
  @Input() retryLabel = "Try Again";
  @Output() retry = new EventEmitter<void>();
}
